import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { disabledStyles, pxToRem, withTransientProps } from '@lbcamden/lib-react';

export const RiskMatrixRoot = styled('div', withTransientProps)<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  ${({ $disabled }) => $disabled && disabledStyles};
`;

export const MatrixContainer = styled.div`
  display: flex;
`;

export const MatrixLeft = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: ${pxToRem(40)} auto;
  align-self: flex-end;
  border: ${({ theme }) => theme.borderLight};
  border-right: 0;
`;

export const MatrixInner = styled.div`
  display: grid;
  flex: 3;
  grid-template-columns: repeat(3, auto);
  border: ${({ theme }) => theme.borderLight};
`;

export const GridCell = styled('div', withTransientProps)<{ $selected?: boolean }>`
  ${({ theme }) => theme.text.body2};
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;

  ${({ theme, $selected }) =>
    $selected &&
    css`
      font-weight: 600;
      background-color: ${theme.colors.secondary};
    `};
`;

const Key = styled(GridCell)`
  font-weight: 600;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
`;

export const KeyX = styled(Key)`
  grid-column: 1 / span 3;
`;

export const KeyY = styled(Key)`
  position: relative;
  grid-row: 1 / span 3;

  > div {
    position: absolute;
    top: ${pxToRem(97)};
    transform: rotate(-90deg);
    transform-origin: top left;
  }
`;

export const HeadingX = styled(GridCell)`
  border-bottom: ${({ theme }) => theme.borderLight};
`;

export const HeadingY = styled(GridCell)`
  min-width: ${pxToRem(80)};
`;
